(() => {
  const root = window.Shopify?.routes?.root || '/';
  const cartDrawer = document.getElementById('cart-drawer');
  let qtyRules = {};
  try {
    qtyRules = JSON.parse(cartDrawer?.dataset.qtyRules || '{}');
  } catch (_) {}

  const money = (cents) =>
    new Intl.NumberFormat('nl-BE', {
      style: 'currency',
      currency: cartDrawer?.dataset.currency || 'EUR',
    }).format(cents / 100);

  const escapeHtml = (value) =>
    String(value).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]);

  /* Header: transparent over the hero, solid once scrolled */
  const header = document.querySelector('[data-header]');
  if (header?.classList.contains('header-wrap--overlay')) {
    const onScroll = () => header.classList.toggle('is-solid', window.scrollY > 40);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* Announcement bar: constant, calm speed regardless of text length (px per second) */
  document.querySelectorAll('.marquee__track').forEach((track) => {
    const group = track.querySelector('.marquee__group');
    if (group) track.style.animationDuration = `${Math.round(group.offsetWidth / 28)}s`;
  });

  /* Hero video: some browsers ignore the muted attribute for autoplay */
  document.querySelectorAll('.hero video').forEach((video) => {
    video.muted = true;
    video.play().catch(() => {});
  });

  /* Clicks: drawers, cart, sliders, spotlight, quantity, gallery */
  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-open]');
    if (opener) {
      event.preventDefault();
      document.getElementById(opener.dataset.open)?.showModal();
    }

    const closer = event.target.closest('[data-close]');
    if (closer) closer.closest('dialog')?.close();

    // Click on the backdrop closes a drawer
    if (event.target instanceof HTMLDialogElement && (event.target.classList.contains('drawer') || event.target.classList.contains('modal'))) {
      event.target.close();
    }

    const cartOpener = event.target.closest('[data-cart-open]');
    if (cartOpener && cartDrawer) {
      event.preventDefault();
      cartOpener.closest('dialog')?.close();
      refreshCart(true);
    }

    const sliderButton = event.target.closest('[data-slider] [data-dir]');
    if (sliderButton) {
      const track = sliderButton.closest('[data-slider]').querySelector('[data-slider-track]');
      track?.scrollBy({ left: Number(sliderButton.dataset.dir) * track.clientWidth * 0.8, behavior: 'smooth' });
    }

    const dot = event.target.closest('[data-spotlight] [data-dot]');
    if (dot) {
      const spotlight = dot.closest('[data-spotlight]');
      spotlight.querySelectorAll('[data-slide]').forEach((slide) => {
        slide.hidden = slide.dataset.slide !== dot.dataset.dot;
      });
      spotlight.querySelectorAll('[data-dot]').forEach((d) => d.setAttribute('aria-current', d === dot));
    }

    const step = event.target.closest('[data-step]');
    if (step) {
      const input = step.closest('[data-qty]')?.querySelector('input');
      if (input) {
        const min = Number(input.min || 1);
        input.value = Math.max(min, Number(input.value || min) + Number(step.dataset.step));
      }
    }

    const thumb = event.target.closest('[data-gallery] [data-thumb]');
    if (thumb) {
      const gallery = thumb.closest('[data-gallery]');
      gallery.querySelectorAll('[data-slide]').forEach((slide) => {
        slide.hidden = slide.dataset.slide !== thumb.dataset.thumb;
      });
      gallery.querySelectorAll('[data-thumb]').forEach((t) => t.setAttribute('aria-current', t === thumb));
    }
  });

  /* Dialogs that should reopen after a form post (e.g. contact form result) */
  document.querySelectorAll('dialog.modal').forEach((dialog) => {
    if (dialog.querySelector('[data-form-result]')) dialog.showModal();
  });

  /* Age gate: one tap (or date of birth when the theme setting asks for it) */
  const gate = document.getElementById('age-gate');
  if (gate) {
    let verified = false;
    try {
      verified = localStorage.getItem('loewi-age') === 'ok';
    } catch (_) {}

    if (!verified) {
      gate.showModal();
      gate.addEventListener('cancel', (event) => event.preventDefault());
    }

    const denied = gate.querySelector('[data-age-denied]');
    const minAge = Number(gate.dataset.minAge || 18);

    // Cookiekeuze in hetzelfde scherm: enkel tonen zolang de bezoeker nog niet koos (Shopify Customer Privacy API).
    const keuze = gate.querySelector('[data-age-keuze]');
    const privacy = () => window.Shopify && window.Shopify.customerPrivacy;
    const toonKeuze = (vragen) => {
      if (!keuze) return;
      keuze.querySelectorAll('[data-toestemming]').forEach((b) => { b.hidden = vragen ? b.dataset.toestemming === '' : b.dataset.toestemming !== ''; });
      const uitleg = gate.querySelector('[data-age-cookies]');
      if (uitleg) uitleg.hidden = !vragen;
    };
    const bekijkKeuze = () => {
      try { const p = privacy(); if (p && typeof p.shouldShowBanner === 'function') toonKeuze(p.shouldShowBanner()); } catch (_) {}
    };
    if (keuze && window.Shopify && window.Shopify.loadFeatures) {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (fout) => { if (!fout) bekijkKeuze(); });
    }
    const bewaarKeuze = (ja) => {
      const p = privacy();
      if (!p || typeof p.setTrackingConsent !== 'function') return;
      const keus = { marketing: ja, analytics: ja, preferences: ja };
      try { p.setTrackingConsent(keus, () => {}); } catch (_) { try { p.setTrackingConsent(ja, () => {}); } catch (__) {} }
      // de aparte Shopify-banner is nu overbodig
      const banner = document.getElementById('shopify-pc__banner');
      if (banner) banner.style.display = 'none';
    };

    gate.querySelector('[data-age-form]')?.addEventListener('submit', (event) => {
      event.preventDefault();
      const data = new FormData(event.target);
      let age = minAge;
      if (data.has('year')) {
        const birth = new Date(Number(data.get('year')), Number(data.get('month')) - 1, Number(data.get('day')));
        const now = new Date();
        age = now.getFullYear() - birth.getFullYear();
        if (now < new Date(now.getFullYear(), birth.getMonth(), birth.getDate())) age -= 1;
      }

      if (age >= minAge) {
        try {
          localStorage.setItem('loewi-age', 'ok');
        } catch (_) {}
        const knop = event.submitter;
        if (knop && knop.dataset.toestemming === 'ja') bewaarKeuze(true);
        if (knop && knop.dataset.toestemming === 'nee') bewaarKeuze(false);
        gate.close();
      } else {
        denied.hidden = false;
      }
    });

    gate.querySelector('[data-age-no]')?.addEventListener('click', () => {
      denied.hidden = false;
    });
  }

  /* Business account request → n8n (form-encoded, so no CORS preflight is needed) */
  document.querySelectorAll('[data-b2b-form]').forEach((form) => {
    const error = form.querySelector('[data-b2b-error]');
    const success = form.parentElement.querySelector('[data-b2b-success]');
    const labels = {
      bedrijfsnaam: 'bedrijfsnaam',
      btw_nummer: 'een geldig Belgisch btw-nummer (BE0123456789)',
      contact_voornaam: 'voornaam',
      contact_achternaam: 'achternaam',
      email: 'een geldig e-mailadres',
      adres: 'leveradres',
      postcode: 'postcode',
      gemeente: 'gemeente',
    };

    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      error.hidden = true;
      if (!form.reportValidity()) return;

      const button = form.querySelector('[type="submit"]');
      const label = button.innerHTML;
      button.disabled = true;
      button.textContent = 'Versturen…';

      try {
        const response = await fetch(form.action, { method: 'POST', body: new URLSearchParams(new FormData(form)) });
        const data = await response.json().catch(() => ({}));
        if (!response.ok || !data.ok) {
          const fields = (data.velden || []).map((name) => labels[name] || name);
          throw new Error(fields.length ? `Kijk even na: ${fields.join(', ')}.` : 'Versturen is niet gelukt. Probeer het later opnieuw of contacteer ons.');
        }
        form.hidden = true;
        success.hidden = false;
      } catch (err) {
        error.textContent = err.message;
        error.hidden = false;
      } finally {
        button.disabled = false;
        button.innerHTML = label;
      }
    });
  });

  /* Wine page: buy bar on phones once the main button scrolls out of view */
  const buyBar = document.querySelector('[data-buy-bar]');
  const mainBuy = document.querySelector('.product__buy');
  if (buyBar && mainBuy && 'IntersectionObserver' in window) {
    new IntersectionObserver(([entry]) => {
      buyBar.hidden = entry.isIntersecting || entry.boundingClientRect.top > 0;
    }).observe(mainBuy);
    buyBar.querySelector('[data-buy-bar-add]').addEventListener('click', () => mainBuy.closest('form').requestSubmit());
  }

  /* Add to cart without leaving the page */
  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('form.js-add-to-cart');
    if (!form || !cartDrawer) return;
    event.preventDefault();

    const button = form.querySelector('[type="submit"]');
    const label = button?.innerHTML;
    if (button) {
      button.disabled = true;
      if (!button.hasAttribute('data-icon-button')) button.textContent = 'Toevoegen…';
    }

    try {
      const response = await fetch(`${root}cart/add.js`, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form),
      });
      const data = await response.json();
      if (!response.ok) throw new Error(data.description || 'Toevoegen mislukt');
      await refreshCart(true);
    } catch (error) {
      const message = form.querySelector('[data-form-error]');
      if (message) {
        message.textContent = error.message;
        message.hidden = false;
      }
    } finally {
      if (button) {
        button.disabled = false;
        button.innerHTML = label;
      }
    }
  });

  /* Quantity changes inside the drawer */
  cartDrawer?.addEventListener('click', async (event) => {
    const change = event.target.closest('[data-line-key]');
    if (!change) return;
    change.disabled = true;
    await fetch(`${root}cart/change.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: change.dataset.lineKey, quantity: Number(change.dataset.quantity) }),
    });
    refreshCart(false);
  });

  async function refreshCart(open) {
    const cart = await fetch(`${root}cart.js`).then((r) => r.json());

    document.querySelectorAll('[data-cart-count]').forEach((el) => {
      el.textContent = cart.item_count;
      if (el.hasAttribute('data-hide-empty')) el.hidden = cart.item_count === 0;
    });

    const body = cartDrawer.querySelector('[data-cart-body]');
    const threshold = Number(cartDrawer.dataset.freeShipping || 0) * 100;
    // gratis verzending vanaf een bedrag (thema-instelling), berekend op het winkelmandtotaal na korting

    if (cart.item_count === 0) {
      body.innerHTML = `
        <div class="drawer__empty">
          <p>Je winkelmand is leeg.</p>
          <a class="btn" href="${root}collections/wijn">Shop onze wijnen</a>
        </div>`;
    } else {
      const lines = cart.items
        .map((item) => {
          const image = item.image ? `${item.image}${item.image.includes('?') ? '&' : '?'}width=240` : '';
          const [min, step] = qtyRules[item.variant_id] || [1, 1];
          const less = item.quantity - step < min ? 0 : item.quantity - step;
          return `
            <li class="line">
              <a class="line__media" href="${item.url}">${image ? `<img src="${image}" alt="" loading="lazy">` : ''}</a>
              <div class="line__info">
                <a class="line__title" href="${item.url}">${escapeHtml(item.product_title)}</a>
                ${(item.line_level_discount_allocations || []).map((k) => `<p class="line__discount">${escapeHtml(k.discount_application.title)} · −${money(k.amount)}</p>`).join('')}
                ${item.properties && item.properties['Boodschap op het kaartje'] ? `<p class="line__note">Kaartje: ${escapeHtml(item.properties['Boodschap op het kaartje'])}</p>` : ''}
                <div class="qty qty--small">
                  <button type="button" data-line-key="${item.key}" data-quantity="${less}" aria-label="Minder">−</button>
                  <span>${item.quantity}</span>
                  <button type="button" data-line-key="${item.key}" data-quantity="${item.quantity + step}" aria-label="Meer">+</button>
                </div>
              </div>
              <p class="line__price">${money(item.final_line_price)}</p>
            </li>`;
        })
        .join('');

      let shipping = '';
      if (threshold) {
        // De proefdoos wordt altijd gratis verzonden (eigen verzendprofiel): telt niet mee voor de drempel.
        const gratis = (cartDrawer.dataset.freeHandles || '').split(',').filter(Boolean);
        const betaald = cart.items.filter((i) => !gratis.includes(i.handle)).reduce((s, i) => s + i.final_line_price, 0);
        const remaining = betaald === 0 ? 0 : threshold - betaald;
        const progress = betaald === 0 ? 100 : Math.min(100, (betaald / threshold) * 100);
        shipping = `<div class="shipping-meter">
             <p>${remaining > 0 ? `Nog ${money(remaining)} tot gratis verzending` : 'Je bestelling wordt gratis verzonden'}</p>
             <div class="shipping-meter__bar"><span style="width:${progress}%"></span></div>
           </div>`;
      }
      // Feestvoorraad: hoeveel flessen wijn nog tot de volgende kortingstrap (de korting zelf rekent Shopify)
      let feest = '';
      const vandaag = new Intl.DateTimeFormat('en-CA', { timeZone: 'Europe/Brussels' }).format(new Date());
      if (cartDrawer.dataset.feest && vandaag <= (cartDrawer.dataset.feestTot || '')) {
        const wijnen = (cartDrawer.dataset.feestHandles || '').split(',').filter(Boolean);
        const flessen = cart.items.filter((i) => wijnen.includes(i.handle)).reduce((s, i) => s + i.quantity, 0);
        const trappen = cartDrawer.dataset.feest.split(',').map((t) => t.split(':').map(Number)).sort((a, b) => a[0] - b[0]);
        const behaald = trappen.filter(([n]) => flessen >= n).pop();
        const volgende = trappen.find(([n]) => flessen < n);
        if (flessen > 0) {
          const regels = [];
          if (behaald) regels.push(`<strong>${behaald[1]}% ${escapeHtml(cartDrawer.dataset.feestNaam || '')}</strong> op je ${flessen} flessen`);
          if (volgende) regels.push(`Nog ${volgende[0] - flessen} ${volgende[0] - flessen === 1 ? 'fles' : 'flessen'} tot ${volgende[1]}% korting`);
          const doel = volgende ? volgende[0] : trappen[trappen.length - 1][0];
          feest = `<div class="shipping-meter feest-meter">
             <p>${regels.join('. ')}</p>
             <div class="shipping-meter__bar"><span style="width:${Math.min(100, (flessen / doel) * 100)}%"></span></div>
           </div>`;
        }
      }
      // kortingen op de hele winkelmand (bv. per doos van 6) apart tonen, anders lijkt het subtotaal fout
      const kortingen = (cart.cart_level_discount_applications || [])
        .map((k) => `<p class="drawer__total drawer__discount"><span>${escapeHtml(k.title)}</span><span>−${money(k.total_allocated_amount)}</span></p>`)
        .join('');
      const pickupTemplate = cartDrawer.querySelector('[data-pickup-template]');
      const pickup = pickupTemplate ? pickupTemplate.innerHTML : '';

      body.innerHTML = `
        <ul class="lines">${lines}</ul>
        <div class="drawer__summary">
          ${kortingen}
          <p class="drawer__total"><span>Subtotaal${cartDrawer.hasAttribute('data-b2b') ? ' excl. btw' : ''}</span><span>${money(cart.total_price)}</span></p>
          ${feest}
          ${shipping}
          ${pickup}
          <p class="drawer__note">${cartDrawer.hasAttribute('data-b2b') ? `Prijzen excl. btw. Incl. 21% btw: ${money(Math.round(cart.total_price * 1.21))}. Btw en verzendkosten komen erbij bij het afrekenen.` : (() => {
            const gratis = (cartDrawer.dataset.freeHandles || '').split(',').filter(Boolean);
            const proef = cart.items.some((i) => gratis.includes(i.handle));
            const betaald = cart.items.filter((i) => !gratis.includes(i.handle)).reduce((s, i) => s + i.final_line_price, 0);
            if (!threshold || betaald === 0 || betaald >= threshold) return 'Je bestelling wordt gratis verzonden.';
            return proef ? `De proefdoos gaat gratis mee. Voor de andere flessen betaal je € 6,95 verzending, gratis vanaf ${money(threshold)}.` : 'Verzending € 6,95 aan huis.';
          })() + ' Zelf ophalen in Loenhout is gratis: kies Afhalen bij het afrekenen.'}</p>
          <a class="btn btn--block" href="${root}checkout">Afrekenen</a>
          <a class="link" href="${root}cart">Bekijk winkelmand</a>
        </div>`;
    }

    if (open && !cartDrawer.open) cartDrawer.showModal();
  }
})();
